import { c as _c } from "react/compiler-runtime";
import { ReactElement, memo } from 'react';
import Link from 'next/link';
import classNames from 'clsx';
import styles from './product-attribute-tile.component.module.scss';
export interface Props {
  readonly element?: ReactElement;
  readonly isAvailable: boolean;
  readonly isSelected: boolean;
  readonly name: string;
  readonly path?: string;
}
function ProductAttributeTileComponent(t0) {
  const $ = _c(17);
  const {
    element,
    isAvailable,
    isSelected,
    name,
    path
  } = t0;
  const t1 = styles[`product-attribute-tile__content--${element === undefined ? "text" : "element"}`];
  const t2 = !isAvailable;
  let t3;
  if ($[0] !== isSelected || $[1] !== t1 || $[2] !== t2) {
    t3 = classNames(styles["product-attribute-tile__content"], t1, "text-xl", {
      [styles["product-attribute-tile__content--selected"]]: isSelected,
      [styles["product-attribute-tile__content--unavailable"]]: t2
    });
    $[0] = isSelected;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const tileContentClass = t3;
  let t4;
  if ($[4] !== element || $[5] !== name) {
    t4 = element ?? <>{name}</>;
    $[4] = element;
    $[5] = name;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const tileContent = t4;
  let t5;
  if ($[7] !== isSelected || $[8] !== path || $[9] !== tileContent || $[10] !== tileContentClass) {
    t5 = path && !isSelected ? <Link prefetch={false} className={tileContentClass} href={path}>{tileContent}</Link> : <span className={tileContentClass}>{tileContent}</span>;
    $[7] = isSelected;
    $[8] = path;
    $[9] = tileContent;
    $[10] = tileContentClass;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== isAvailable) {
    t6 = !isAvailable && <div className={styles["product-attribute-tile__diagonal"]} />;
    $[12] = isAvailable;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <div className={styles["product-attribute-tile"]}>{t5}{t6}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}
export default memo(ProductAttributeTileComponent);